<template>
  <v-layout v-resize="onResize" column style="padding-top: 0px">
    <div class="container-fluid">
      <div class="row" style="margin-top: 0px">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">Master Event
            </div>
            <v-dialog v-model="dialogAddEvent" persistent max-width="800px">
              <v-card>
                <v-card-title>
                  <span class="text-h5">Event</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field v-model="nama_event" label="Nama Event" required color="#F9A825"
                          :disabled="disableCounter"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40"
                          transition="scale-transition" offset-y min-width="auto">
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="data_tgl_lahir" label="Tanggal Event" prepend-icon="mdi-calendar"
                              readonly v-bind="attrs" v-on="on" color="#F9A825"
                              :disabled="disableCounter"></v-text-field>
                          </template>
                          <v-date-picker v-model="data_tgl_lahir" @input="menu2 = false"></v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-menu ref="menu_jam" v-model="menu_jam" :close-on-content-click="false" :nudge-right="40"
                          :return-value.sync="event_jam" transition="scale-transition" offset-y max-width="290px"
                          min-width="290px">
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="event_jam" label="Jam Event"
                              prepend-icon="mdi-clock-time-four-outline" readonly v-bind="attrs" v-on="on"
                              color="#F9A825" :disabled="disableCounter"></v-text-field>
                          </template>
                          <v-time-picker v-if="menu_jam" v-model="event_jam" full-width
                            @click:minute="$refs.menu_jam.save(event_jam)"></v-time-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="12">
                        <v-select :items="listKotaDomisili" label="Lokasi Event" required v-model="lokasi_event"
                          item-text="DESKRIPSI_DATA" item-value="ID_DATA" color="#F9A825" :disabled="disableCounter"
                          v-on:change="resetListAdminHuangYi()" @click:append="toggle2"></v-select>
                      </v-col>
                      <v-col cols="12">
                        <v-combobox :items="newListKotaDom" item-text="DESKRIPSI_DATA" item-value="ID_DATA" multiple
                          chips :menu-props="{ value: autoSelectMenu2 }" @click:append="toggle2"
                          v-model="data_kota_show_event" refs="comboboxShow" label="Show Kota Event" color="#F9A825">
                        </v-combobox>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field label="Alamat Event" v-model="alamat_event" required color="#F9A825"
                          :disabled="disableCounter"></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field label="Deskripsi Event" v-model="deskripsi_event" required color="#F9A825"
                          :disabled="disableCounter"></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field label="Link" v-model="url_event" required color="#F9A825"
                          :disabled="disableCounter"></v-text-field>
                      </v-col>
                    </v-row>
                    <v-data-table :headers="headersDialog" :items="dataAdminHuangYi" item-key="ID_TRX"
                      class="elevation-1" show-select v-model="listAdminHuangYi">
                      <template v-slot:top>
                        <v-toolbar flat>
                          <v-toolbar-title>Admin Event</v-toolbar-title>
                          <v-spacer></v-spacer>
                          <v-btn color="success" dark class="mb-2 mr-2" @click="getDataHuangYiDomisili()"
                            :disabled="disableCounter">
                            Tambah Admin Event
                          </v-btn>
                          <v-btn color="red" dark class="mb-2" :disabled="disableCounter" @click="deleteAdminAbsen()">
                            Hapus Admin Event
                          </v-btn>
                          <v-dialog v-model="dialogAddAdminEvent" max-width="700px">
                            <v-card>
                              <v-toolbar color="#F9A825" dark>Tambah Admin Event</v-toolbar>
                              <v-card-text>
                                <v-container>
                                  <v-data-table :headers="headersDialog2" :items="dataHuangYi"
                                    :search="searchDataHuangyi" item-key="ID_TRX" class="elevation-1"
                                    :loading="loading_data_huangyi" loading-text="Fetching Data" show-select
                                    v-model="listHuangYi">
                                    <template v-slot:top>
                                      <v-text-field v-model="searchDataHuangyi" append-icon="mdi-magnify" label="Search"
                                        single-line hide-details class="mr-2 ml-2 mb-2"></v-text-field>
                                    </template>
                                    <template v-slot:[`item.actions`]="{ item }">
                                      <v-icon small class="mr-2">
                                        mdi-pencil
                                      </v-icon>
                                      <v-icon small>
                                        mdi-delete
                                      </v-icon>
                                    </template>
                                  </v-data-table>
                                </v-container>
                              </v-card-text>

                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" text @click="closeDalogAddAdminEvent()">
                                  Cancel
                                </v-btn>
                                <v-btn color="blue darken-1" text @click="insertHuangYitoAdmin()">
                                  Tambah Admin
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </v-toolbar>
                        <v-divider></v-divider>
                      </template>
                      <template v-slot:[`item.actions`]="{ item }">
                        <v-icon small class="mr-2">
                          mdi-pencil
                        </v-icon>
                        <v-icon small>
                          mdi-delete
                        </v-icon>
                      </template>
                    </v-data-table>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="closeDialogEvent()">
                    Close
                  </v-btn>
                  <v-btn color="blue darken-1" text @click="submitEvent()" :disabled="disabledButtonforSU">
                    Save
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <div class="card-body">
              <v-dialog v-model="dialogLoading" width="150px" height="auto">
                <v-card width="150px" height="150px" style="text-align: center">
                  <v-progress-circular :size="70" :width="7" color="orange" indeterminate persistent
                    style="margin-top: 40px"></v-progress-circular>
                </v-card>
              </v-dialog>
              <!-- <div class="row">
                <div class="col">
                  <v-select
                    :items="listKotaDaftar"
                    label="Tao Ying City"
                    required
                    v-model="search_kota"
                    item-text="DESKRIPSI_DATA"
                    item-value="ID_DATA"
                    color="#F9A825"
                    v-on:change="searchData()"
                  ></v-select>
                </div>
                <div class="col">
                  <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="search_tgl_daftar"
                        label="Tao Ying Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        @blur="search_tgl_daftar_raw = parseDate(search_tgl_daftar)"
                        v-on="on"
                        color="#F9A825"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="search_tgl_daftar_raw"
                      v-on:change="searchData()"
                      color="#F9A825"
                      @input="menu2 = false"
                    ></v-date-picker>
                  </v-menu>
                </div>
              </div> -->
              <v-data-table :headers="headers" :items="event" :search="search" show-select item-key="ID"
                v-model="selected">
                <template v-slot:top>
                  <v-toolbar flat>
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details
                      class="mr-2"></v-text-field>
                    <v-btn style="margin-right: 20px" color="#3EB650" dark @click="newEvent()"
                      :disabled="disabledButtonforSU">New Event</v-btn>
                    <v-btn style="margin-right: 20px" color="red" dark @click="deleteEvent()">Delete Event</v-btn>
                  </v-toolbar>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-icon small class="mr-2" @click="editItem(item)">
                    mdi-pencil
                  </v-icon>
                  <v-icon small class="mr-2" @click="cetakAbsensi(item)">
                    mdi-printer
                  </v-icon>
                  <v-icon small @click="deleteItem(item)">
                    mdi-delete
                  </v-icon>
                </template>
                <!-- <template v-slot:no-data>
                  <v-btn
                    color="primary"
                    @click="initialize"
                  >
                    Reset
                  </v-btn>
                </template> -->
              </v-data-table>

            </div>
          </div>
        </div>
      </div>
    </div>
  </v-layout>
</template>

<script>
import axios from '@/axios'
import FormDaftar from '../../components/modal/FormDaftar.vue'
import FormGraduateTaoying from '../../components/modal/FormGraduateTaoying.vue'
import FormUploadSignature from '../../components/modal/FormUploadSignature.vue'
import DataTableHistory from '../../components/modal/DataTableHistory.vue'
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
export default {
  data: () => ({
    sortBy: 'NO_TAOYU',
    sortDesc: false,
    search: '',
    searchDataHuangyi: '',
    isMobile: false,
    search_kota: '',
    search_tgl_daftar: '',
    search_tgl_daftar_raw: '',
    dialogAddEvent: false,
    dialogLoading: false,
    dialogGenUser: false,
    listKotaDomisili: [],
    listKotaDom: [],
    newListKotaDom: [],
    title_dialog: '',
    id_event: '',
    disableCounter: false,
    disabledButtonforSU: false,
    nama_event: '',
    data_kota_show_event: [],
    menu_jam: false,
    event_jam: null,
    tanggal_event: '',
    lokasi_event: '',
    alamat_event: '',
    deskripsi_event: '',
    loading_data_huangyi: false,
    menu2: false,
    dialogAddAdminEvent: false,
    selected: [],
    dataHuangYi: [],
    dataAdminHuangYi: [],
    listHuangYi: [],
    listAdminHuangYi: [],
    dataNotifikasiRaw: {},
    url_link: '',
    autoSelectMenu2: false,
    data_tgl_lahir: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    data_tgl_lahir: new Date().toISOString().substr(0, 10),
    // data_tgl_daftar:'01-01-1990',
    data_tgl_daftar: '',
    data_tgl_daftar_raw: new Date().toISOString().substr(0, 10),
    headers: [
      { text: 'Nama Event', align: 'start', value: 'NAMA_EVENT', },
      { text: 'Tanggal Event', value: 'TANGGAL_EVENT' },
      { text: 'Lokasi Event', value: 'LOKASI_EVENT' },
      // { text: 'Alamat Event', value: 'ALAMAT_EVENT', filterable: false },
      { text: 'Jam Event', value: 'JAM_EVENT', filterable: false },
      { text: 'Deskripsi Event', value: 'DESKRIPSI_EVENT', filterable: false },
      { text: 'Pin Admin', value: 'PIN_ADMIN', filterable: false },
      // { text: 'Created At', value: 'CREATE_DATE', sortable: true },
      { text: 'Actions', value: 'actions', filterable: false }
    ],
    headersDialog: [
      { text: 'No HuangYi', align: 'start', value: 'NO_HUANGYI', },
      { text: 'Nama', value: 'NAMA_INDO' }
    ],
    headersDialog2: [
      { text: 'No HuangYi', align: 'start', value: 'NO_HUANGYI', },
      { text: 'Nama', value: 'NAMA_INDO' },
      { text: 'Domisili', value: 'KOTA_DOM' }
    ],
    event: [],
    id_data_table: '',
    id_data_table2: '',
    editedIndex: -1,
    editedItem: [],
    flagEdited: false,
    role: 0,
    statusDialog: 0,
    singleSelect: false,
    dataTables: [],
  }),
  computed: {
    // formTitle () {
    //     return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    // },
  },
  watch: {
    dialog(val) { val || this.close() },
    dialog2(val) { val || this.close() },
    search_tgl_daftar_raw(val) {
      this.search_tgl_daftar = this.formatDate(this.search_tgl_daftar_raw)
      // new Date(this.search_tgl_daftar_raw).toLocaleDateString('es-CL')
    },
  },
  created() {
    this.initialize()
  },
  beforeCreate: function () {
    if (!this.$session.exists()) {
      this.$router.push('/')
    }
  },
  watch: {
  },
  methods: {
    onResize() {
      if (window.innerWidth < 769)
        this.isMobile = true;
      else
        this.isMobile = false;
    },
    toggle2() {
      this.autoSelectMenu2 = !this.autoSelectMenu2

    },
    initialize() {
      // console.log('Dash '+this.$session.get('token'));   
      axios({
        method: 'get',
        url: 'master_data',
        headers: {
          Authorization: 'Bearer ' + this.$session.get('token'),
        },
      }).then(response => {
        // console.log('Kota '+response.data.Kota_Daftar);
        // console.log(response.data);
        this.listKotaDom = response.data.Kota_Domisili;
        this.tmp_data_kota = []
      }).catch(error => {
        Swal.fire({
          title: 'Peringatan',
          icon: 'error',
          text: error
        });
      });
      if (this.$session.get('role') === '1') {
        this.disabledButtonforSU = true;
        axios({
          method: 'get',
          url: 'master_data',
          headers: {
            Authorization: 'Bearer ' + this.$session.get('token'),
          },
        }).then(response => {
          // console.log('Kota '+response.data.Kota_Daftar);
          // console.log(response.data);
          this.listKotaDomisili = response.data.Kota_Domisili;
          axios({
            method: 'post',
            url: 'getAllEventData',
            headers: {
              Authorization: 'Bearer ' + this.$session.get('token'),
            },
            data: {
              kota_domisili_terdaftar: this.listKotaDomisili
            }
          }).then(response => {
            console.log(response.data.data);
            this.event = response.data.data;
          }).catch(error => {
            // Swal.fire({
            //            title:'Peringatan',
            //            icon :'error',
            //            text:'Failed to retrieve List City !'
            //    });
          });
        }).catch(error => {
          Swal.fire({
            title: 'Peringatan',
            icon: 'error',
            text: error
          });
        });
      } else {
        axios({
          method: 'post',
          url: 'get_list_kota_domisili',
          headers: {
            Authorization: 'Bearer ' + this.$session.get('token'),
          },
          data: {
            user_id: this.$session.get('user_id')
          }
        }).then(response => {
          this.listKotaDomisili = response.data;
          axios({
            method: 'post',
            url: 'getAllEventData',
            headers: {
              Authorization: 'Bearer ' + this.$session.get('token'),
            },
            data: {
              kota_domisili_terdaftar: this.listKotaDomisili
            }
          }).then(response => {
            console.log(response.data.data);
            this.event = response.data.data;
          }).catch(error => {
            // Swal.fire({
            //            title:'Peringatan',
            //            icon :'error',
            //            text:'Failed to retrieve List City !'
            //    });
          });
        }).catch(error => {
          // Swal.fire({
          //            title:'Peringatan',
          //            icon :'error',
          //            text:'Failed to retrieve List City !'
          //    });
        });
      }

    },
    newEvent() {
      this.dialogAddEvent = true;
      this.disableCounter = false;
    },
    formatDate(val) {
      if (!val) {
        return null
      } else {
        return new Date(val).toLocaleDateString('es-CL');

      }
    },
    parseDate(val) {
      if (val !== null && typeof (val) !== 'undefined') {
        return new Date(val).toISOString().substr(0, 10)
      } else {
        return null
      }

    },
    submitEvent() {
      if (this.nama_event && this.data_tgl_lahir && this.lokasi_event && this.alamat_event && this.deskripsi_event && this.event_jam) {
        this.onSubmit();
      } else {
        Swal.fire({
          title: 'Peringatan',
          icon: 'warning',
          text: 'Harap Isi Semua data Event dengan lengkap!'
        });
      }
    },
    closeDialogEvent() {
      this.dialogAddEvent = false;
      this.nama_event = '';
      this.data_tgl_lahir = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
      this.lokasi_event = '';
      this.url_event = '';
      this.alamat_event = '';
      this.deskripsi_event = '';
      this.id_event = '';
      this.event_jam = '';
      this.data_kota_show_event = '';
      this.dataAdminHuangYi = [];
    },
    onSubmit() {
      var nama_event = this.nama_event;
      var deskripsi_event = this.deskripsi_event;
      if (this.id_event === '') {
        axios({
          method: 'post',
          url: 'saveEvent',
          headers: {
            Authorization: 'Bearer ' + this.$session.get('token'),
          },
          data: {
            nama_event: this.nama_event,
            tanggal_event: this.data_tgl_lahir,
            lokasi_event: this.lokasi_event,
            alamat_event: this.alamat_event,
            deskripsi_event: this.deskripsi_event,
            jam_event: this.event_jam,
            url_event: this.url_event,
            list_admin: this.dataAdminHuangYi,
            show_kota_event: this.data_kota_show_event,
            user_id: this.$session.get('user_id')
          }
        }).then(response => {
          // alert(response.data);
          // var idEvent = response.data;
          var concatIDPengumuman = '';
          // axios({
          //   method: 'post',
          //   url: 'getDataNotificationIDforEvent',
          //   headers: {
          //     Authorization: 'Bearer ' + this.$session.get('token'),
          //   },
          //   data: {
          //     user_id: this.$session.get('user_id')
          //   }
          // }).then(response => {
          //   this.dataNotifikasiRaw = response.data.data;
          //   var counter = 1;
          //   try {
          //     for (let i = 0; i < this.dataNotifikasiRaw.length; i++) {
          //       concatIDPengumuman += '"' + this.dataNotifikasiRaw[i].token_notifikasi + '",';
          //       // console.log(concatIDPengumuman);
          //       if (counter % 100 === 0) {
          //         concatIDPengumuman = concatIDPengumuman.slice(0, -1);
          //         axios({
          //           method: 'post',
          //           url: 'https://fcm.googleapis.com/fcm/send',
          //           headers: {
          //             "Content-Type": "application/json",
          //             "Authorization": "key=AAAAmHQbdBc:APA91bESWZqn98GvZAM5IqbTs_cfUz9OCrln0fr6ameLFU6HFQdVnjvIOt-LchLYu4habbjZejlVj3J_lf1L6IwiMdHFwX9gBnl4UnGO2rN7pUUYL4TSZYDtb_Ge1ue1FsPQcXN4_0dU"
          //           },
          //           data: this.concatNotifikasi(concatIDPengumuman, nama_event, deskripsi_event)
          //         }).then(response => {
          //           console.log(response);
          //           // this.initialize();
          //         }).catch(error => {
          //           // Swal.fire({
          //           //            title:'Peringatan',
          //           //            icon :'error',
          //           //            text:'Failed to retrieve List City !'
          //           //    });
          //         });
          //         concatIDPengumuman = '';
          //       }
          //       counter = counter + 1;
          //     }
          //   } catch (err) {
          //     console.log(err);
          //   }
          //   concatIDPengumuman = concatIDPengumuman.slice(0, -1);
          //   axios({
          //     method: 'post',
          //     url: 'https://fcm.googleapis.com/fcm/send',
          //     headers: {
          //       "Content-Type": "application/json",
          //       "Authorization": "key=AAAAmHQbdBc:APA91bESWZqn98GvZAM5IqbTs_cfUz9OCrln0fr6ameLFU6HFQdVnjvIOt-LchLYu4habbjZejlVj3J_lf1L6IwiMdHFwX9gBnl4UnGO2rN7pUUYL4TSZYDtb_Ge1ue1FsPQcXN4_0dU"
          //     },
          //     data: this.concatNotifikasi(concatIDPengumuman, nama_event, deskripsi_event)
          //   }).then(response => {
          //     console.log(response);
          //     // this.initialize();
          //   }).catch(error => {
          //     // Swal.fire({
          //     //            title:'Peringatan',
          //     //            icon :'error',
          //     //            text:'Failed to retrieve List City !'
          //     //    });
          //   });
          //    Swal.fire({
          //               title:'Peringatan',
          //               icon :'success',
          //               text: 'Data Berhasil Disimpan'
          //           });
          //   this.closeDialogEvent();
          //   this.initialize();
          // }).catch(error => {

          // });
          Swal.fire({
            title: 'Peringatan',
            icon: 'success',
            text: 'Data Berhasil Disimpan'
          });
          this.closeDialogEvent();
          this.initialize();
        }).catch(error => {

        });
      } else {
        // console.log(this.dataAdminHuangYi);
        axios({
          method: 'post',
          url: 'updateEvent',
          headers: {
            Authorization: 'Bearer ' + this.$session.get('token'),
          },
          data: {
            id_event: this.id_event,
            nama_event: this.nama_event,
            tanggal_event: this.data_tgl_lahir,
            lokasi_event: this.lokasi_event,
            alamat_event: this.alamat_event,
            deskripsi_event: this.deskripsi_event,
            jam_event: this.event_jam,
            url_event: this.url_event,
            list_admin: this.dataAdminHuangYi,
            show_kota_event: this.data_kota_show_event,
            user_id: this.$session.get('user_id')
          }
        }).then(response => {
          Swal.fire({
            title: 'Peringatan',
            icon: 'success',
            text: 'Data Berhasil Diupdate'
          });
          this.closeDialogEvent();
          this.initialize();
        }).catch(error => {
          // Swal.fire({
          //            title:'Peringatan',
          //            icon :'error',
          //            text:'Failed to retrieve List City !'
          //    });
        });
      }
    },
    concatNotifikasi(data, judul, deskripsi) {
      var textDesc = deskripsi;
      var gambar = '';
      var string = "{\"registration_ids\": [" + data + "],\"notification\": \{\"title\": \"" + judul + "\",\"body\": \"" + textDesc.substr(0, 100) + "\",\"image\": \"" + gambar + "\"\}} ";

      return string;
      // return {
      //   "registration_ids": [data],
      //   "notification": {
      //     "title": "Upacara TaoYing & Kweepang – Jakarta 5 June 2022",
      //     "body": "Telah sukses diadakan upacara Taoying di Jakarta Zhen Cheng Gong Taokwan dipimpin oleh Lie Ming Shen Dao Shi, dan dihadiri oleh 30 Taoyu yang baru di taoying",
      //     "image": "https://siutao.com/wp-content/uploads/2022/06/Taoying-5-Juni-2022-Zhen-Cheng-Gong-3-1200x480.jpeg"
      //   }
    },
    editItem(item) {
      // console.log(item);
      const today = new Date();
      const yyyy = today.getFullYear();
      let mm = today.getMonth() + 1; // Months start at 0!
      let dd = today.getDate();

      if (dd < 10) dd = '0' + dd;
      if (mm < 10) mm = '0' + mm;

      var dateNow = yyyy + '-' + mm + '-' + dd;
      if (this.$session.get('role') === '1') {
        this.disableCounter = true;
      } else {
        if (item.TANGGAL_EVENT < dateNow) {
          this.disableCounter = true;
        }
        else {
          this.disableCounter = false;
        }
      }
      this.dataAdminHuangYi.splice(0);
      axios({
        method: 'post',
        url: 'getEventDataByIdForEdit',
        headers: {
          Authorization: 'Bearer ' + this.$session.get('token'),
        },
        data: {
          id: item.ID
        }
      }).then(response => {
        // console.log(response.data.data_show);
        this.data_kota_show_event = [];
        var list_kota_domisili = this.listKotaDom;
        this.id_event = response.data.data.ID;
        this.nama_event = response.data.data.NAMA_EVENT;
        this.data_tgl_lahir = response.data.data.TANGGAL_EVENT;
        this.lokasi_event = response.data.data.LOKASI_EVENT;
        this.alamat_event = response.data.data.ALAMAT_EVENT;
        this.url_event = response.data.data.URL_EVENT;
        this.event_jam = response.data.data.JAM_EVENT;
        this.deskripsi_event = response.data.data.DESKRIPSI_EVENT;
        try {
          this.newListKotaDom = this.listKotaDom.filter(function (el) {
            return el.ID_DATA != response.data.data.ID
          });
        } catch (err) {
          console.log(err.message);
        }
        response.data.data_show.forEach(data => {
          try {
            var tmp3 = list_kota_domisili.find(item => item.ID_DATA === parseInt(data.ID_KOTA_DOM));
            if (tmp3) this.data_kota_show_event.push(tmp3);
          }
          catch (err) {
            console.log(err.message);
          }
        });
        // response.data.data_show.forEach(function (arrayItem){

        // })
        // this.data_kota_show_event = response.daa.daa
      }).catch(error => {
        // Swal.fire({
        //            title:'Peringatan',
        //            icon :'error',
        //            text:'Failed to retrieve List City !'
        //    });
      });
      axios({
        method: 'post',
        url: 'getDataMapEventById',
        headers: {
          Authorization: 'Bearer ' + this.$session.get('token'),
        },
        data: {
          id: item.ID
        }
      }).then(response => {
        this.dataAdminHuangYi = response.data;
      }).catch(error => {
        // Swal.fire({
        //            title:'Peringatan',
        //            icon :'error',
        //            text:'Failed to retrieve List City !'
        //    });
      });
      this.dialogAddEvent = true;
    },
    deleteItem(item) {
      axios({
        method: 'post',
        url: 'deleteDataEvent',
        headers: {
          Authorization: 'Bearer ' + this.$session.get('token'),
        },
        data: {
          id_event: item.ID,
          single_delete: 'Y',
          role_id: this.$session.get('role'),
          user_id: this.$session.get('user_id')
        }
      }).then(response => {
        if (response.data === 'Data Event Masih Aktif!') {
          Swal.fire({
            title: 'Peringatan',
            icon: 'warning',
            text: response.data
          });
        } else {
          Swal.fire({
            title: 'Peringatan',
            icon: 'success',
            text: response.data
          });
        }
        this.initialize();
      }).catch(error => {
        // Swal.fire({
        //            title:'Peringatan',
        //            icon :'error',
        //            text:'Failed to retrieve List City !'
        //    });
      });
    },
    deleteEvent() {
      axios({
        method: 'post',
        url: 'deleteDataEvent',
        headers: {
          Authorization: 'Bearer ' + this.$session.get('token'),
        },
        data: {
          data_event: this.selected,
          single_delete: 'N',
          role_id: this.$session.get('role'),
          user_id: this.$session.get('user_id')
        }
      }).then(response => {
        if (response.data === 'Data Event Masih Aktif!') {
          Swal.fire({
            title: 'Peringatan',
            icon: 'warning',
            text: response.data
          });
        } else {
          Swal.fire({
            title: 'Peringatan',
            icon: 'success',
            text: response.data
          });
        }
        this.initialize();
      }).catch(error => {
        // Swal.fire({
        //            title:'Peringatan',
        //            icon :'error',
        //            text:'Failed to retrieve List City !'
        //    });
      });
    },
    cetakAbsensi(item) {
      this.dialogLoading = true;
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger'
        },
        buttonsStyling: false
      })

      swalWithBootstrapButtons.fire({
        // title: 'Are you sure?',
        text: "Are you sure?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, download pdf!',
        cancelButtonText: 'No, cancel!',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          axios({
            method: 'post',
            url: 'cetakReportAbsensi',
            headers: {
              Authorization: 'Bearer ' + this.$session.get('token'),
            },
            responseType: 'blob', // important
            data: {
              id: item.ID
            },

          }).then(response => {
            console.log(response);
            if (response) {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', 'ReportApprovalTaoyu.pdf');
              document.body.appendChild(link);
              link.click();
              this.dialogLoading = false;
              // this.initialize();
            }
          }).catch(error => {
            this.dialogLoading = false;
            console.log(error.response);
          });
        } else if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.cancel
        ) {
          swalWithBootstrapButtons.fire(
            'Cancelled',
            'It is okay :)',
            'info'
          )
          this.dialogLoading = false;
        }
      })
      // this.dialogLoading=true;
      // confirm('Are you sure to print this profile ?') &&
      // axios({
      //     method: 'post',
      //     url: 'http://sd6webdev.indomaret.lan/laravel-passport/public/api/profile_data',
      //     responseType: 'blob', // important
      //     data:{
      //         id: item.ID_TRX
      //     },
      //     headers: {
      //       Authorization: 'Bearer ' + this.$session.get('token'),
      //     },
      // }).then(response => {
      //     // console.log(response);
      //     if(response){
      //         const url = window.URL.createObjectURL(new Blob([response.data]));
      //         const link = document.createElement('a');
      //         link.href = url;
      //         link.setAttribute('download', item.NAMA_INDO+'.pdf');
      //         document.body.appendChild(link);
      //         link.click();
      //         this.dialogLoading=false;
      //         // this.initialize();
      //     }
      // }).catch(error => {
      //     this.dialogLoading=false;
      //     console.log(error.response);
      //});
    },
    closeDalogAddAdminEvent() {
      this.dialogAddAdminEvent = false;
    },
    getDataHuangYiDomisili() {
      this.listHuangYi.splice(0);
      if (this.lokasi_event === '') {
        Swal.fire({
          title: 'Peringatan',
          icon: 'warning',
          text: 'Anda Belum Memilih Lokasi Event!'
        });
      } else {
        this.dialogAddAdminEvent = true;
        this.dataHuangYi = [];
        this.loading_data_huangyi = true;
        axios({
          method: 'post',
          url: 'get_data_huangyi_for_admin_event',
          headers: {
            Authorization: 'Bearer ' + this.$session.get('token'),
          },
          data: {
            kota_domisili: this.lokasi_event,
            list_no_HuangYi: this.dataAdminHuangYi
          }
        }).then(response => {
          // console.log(response.data);
          this.dataHuangYi = response.data;
          this.loading_data_huangyi = false;
          // this.event=response.data.data;
        }).catch(error => {
          // Swal.fire({
          //            title:'Peringatan',
          //            icon :'error',
          //            text:'Failed to retrieve List City !'
          //    });
        });
      }
    },
    insertHuangYitoAdmin() {
      this.listHuangYi.forEach((item) => {
        this.dataAdminHuangYi.push({
          ID_TRX: item.ID_TRX,
          NO_HUANGYI: item.NO_HUANGYI,
          NAMA_INDO: item.NAMA_INDO
        })
      });
      this.dialogAddAdminEvent = false;
    },
    deleteAdminAbsen() {
      if (this.listAdminHuangYi.length === 0) {
        Swal.fire({
          title: 'Peringatan',
          icon: 'warning',
          text: 'Anda Belum Memilih Admin Yang Akan diHapus!'
        });
      } else {
        for (var i = 0; i < this.listAdminHuangYi.length; i++) {
          const index = this.dataAdminHuangYi.indexOf(this.listAdminHuangYi[i]);
          this.dataAdminHuangYi.splice(index, 1);
        }
        this.listAdminHuangYi.splice(0);
      }
    },
    resetListAdminHuangYi() {
      // alert(this.data_kota_show_event);
      // alert(this.lokasi_event);
      // this.$refs.comboBox.emit("blur");
      var id_event = this.lokasi_event;
      this.data_kota_show_event = [];
      this.newListKotaDom = this.listKotaDom.filter(function (el) {
        return el.ID_DATA != id_event
      });
      this.dataAdminHuangYi.splice(0);
      ;
    }
  },
  components: {
    FormDaftar,
    FormGraduateTaoying,
    FormUploadSignature,
    DataTableHistory
    // FormValidasi,
  },
}
</script>

<style>
.butt {
  padding: 10px;
  background-color: #ebaa1f;
}

.mobile {
  color: #333;
}

@media screen and (max-width: 768px) {
  .mobile table.v-table tr {
    max-width: 100%;
    position: relative;
    display: block;
  }

  .mobile table.v-table tr:nth-child(odd) {
    border-left: 6px solid deeppink;
  }

  .mobile table.v-table tr:nth-child(even) {
    border-left: 6px solid cyan;
  }

  .mobile table.v-table tr td {
    display: flex;
    width: 100%;
    border-bottom: 1px solid #f5f5f5;
    height: auto;
    padding: 10px;
  }

  .mobile table.v-table tr td ul li:before {
    content: attr(data-label);
    padding-right: 0.5em;
    text-align: left;
    display: block;
    color: #999;
  }

  .v-datatable__actions__select {
    width: 50%;
    margin: 0px;
    justify-content: flex-start;
  }

  .mobile .theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
    background: transparent;
  }
}

.flex-content {
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.flex-item {
  padding: 5px;
  width: 50%;
  height: 40px;
  font-weight: bold;
}
</style>
